import { writable } from "svelte/store";
import { createHooks } from "@wordpress/hooks";

const hooks = createHooks();

function init() {
  const { subscribe, update, set } = writable();

  return {
    subscribe,
    update,
    set,
    initHooksStore: () => set(hooks),
    doAction: (hookName, arg1, arg2, moreArgs, finalArg) =>
      hooks.doAction(hookName, arg1, arg2, moreArgs, finalArg),
    addAction: (hookName, namespace, callback, priority) =>
      hooks.addAction(hookName, namespace, callback, priority),
    applyFilters: (hookName, content, arg1, arg2, moreArgs, finalArg) =>
      hooks.applyFilters(hookName, content, arg1, arg2, moreArgs, finalArg),
    addFilter: (hookName, namespace, callback, priority) =>
      hooks.addFilter(hookName, namespace, callback, priority),
    hasFilter: (hookName, namespace) => hooks.hasFilter(hookName, namespace),
    hasAction: (hookName, namespace) => hooks.hasAction(hookName, namespace),
    didAction: (hookName) => hooks.didAction(hookName),
    removeAllFilters: (hookName) => hooks.removeAllFilters(hookName),
  };
}

export const hooksStore = init();
